@if (brands) {
  <div class="brands-carousel">
    <swiper-container class="h-100" [sale4AllSwiper]="config" init="false" dir="rtl">
      <a mat-button routerLink="/brands">{{'sale4you.brands.ShowAllBrands' | translate }}</a>
      @for (brand of brands; track brand) {
        <swiper-slide>
          <div class="p-0">
            <a [routerLink]="['/brands', brand.name]" class="brand-item">
              <img [src]="brand.image" [alt]="brand.name" loading="lazy">
            </a>
          </div>
        </swiper-slide>
      }
      <button aria-label="הקודם" mat-icon-button class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
      <button aria-label="הבא" mat-icon-button class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
    </swiper-container>
  </div>
}
